import Vue from 'vue';
import App from './App.vue';
import axios from 'axios';

// casirest config
// axios.defaults.baseURL = 'https://pizza.pre.zone/casirest/v3';
// axios.defaults.headers.common['X-API-Key'] = '6ef2ee83-264f-631a-e418-bd30d7c9163b';

// axios.defaults.baseURL = 'https://ebus-i19518.preview.cantamen.de/casirest/v1';
// axios.defaults.headers.common['X-API-Key'] = 'f552d21c-389d-efcb-3d5b-3df570def064';

axios.defaults.baseURL = 'https://de1.cantamen.de/casirest/v3';
axios.defaults.headers.common['X-API-Key'] = 'b7214e7c-852c-73bd-7bd9-f1884f0629bf';

Vue.config.productionTip = false;

new Vue({
	render: h => h(App)
}).$mount('#app');
